__turbopack_context__.v({
  "buttons": "GeoPopup-module__ybX_Iq__buttons",
  "close": "GeoPopup-module__ybX_Iq__close",
  "content": "GeoPopup-module__ybX_Iq__content",
  "description": "GeoPopup-module__ybX_Iq__description",
  "link": "GeoPopup-module__ybX_Iq__link",
  "title": "GeoPopup-module__ybX_Iq__title",
  "viewport": "GeoPopup-module__ybX_Iq__viewport",
});
